/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TariffaMensaUpsertForm } from './tariffa-mensa-upsert-form';
import { ProfiloStudenteSimulazioneForm } from './profilo-studente-simulazione-form';


export interface TariffaMensaSimulaForm { 
    tariffa: TariffaMensaUpsertForm;
    profilo: ProfiloStudenteSimulazioneForm;
}

